var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.showLoading ? _c('div', [_c('Loading')], 1) : _vm._e(), _vm.getModuleConfig('page_kv_image') ? _c('img', {
    staticClass: "w-100",
    attrs: {
      "src": _vm.getModuleConfig('page_kv_image')
    }
  }) : _vm._e(), _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("".concat(_vm.pageKey, ".form_title"))) + " ")]), _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("".concat(_vm.pageKey, ".form_desc"))) + " "), _vm.errorHtml ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.errorHtml)
    }
  }) : _vm._e()]), _c('b-card', {
    staticClass: "mt-3",
    attrs: {
      "img-src": _vm.avatarUrl,
      "img-alt": "Image",
      "img-top": ""
    }
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.lineData.displayName) + " ")])])], 1), _c('div', {
    staticClass: "page__button"
  }, [_c('MemberButton', {
    attrs: {
      "button-text": _vm.getModuleConfig("".concat(_vm.pageKey, ".button_text")),
      "button-url": _vm.getModuleConfig("".concat(_vm.pageKey, ".button_url")),
      "type": _vm.getModuleConfig("".concat(_vm.pageKey, ".button_action"))
    }
  }), _vm.showRedirect ? _c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.redirect
    }
  }, [_vm._v(" " + _vm._s(_vm.redirectText) + " ")]) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }